var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-empty"},[_c('img',{staticClass:"c-empty-img",attrs:{"src":_vm.emptyImg,"alt":""}}),_c('div',{staticClass:"c-empty-text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2),(_vm.$slots.action)?_c('div',{staticClass:"c-empty-action"},[_vm._t("action")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }